import { CustomLibary } from "@/shared/Event";
import { DateTimePeriodDto, OutlookAppointmentBaseInfoDto, OutlookAppointmentDto, OutlookAppointmentRecurrenceDto, OutlookRecipientDto } from "../dto";

export const TokenIAppointmentManager = "IAppointmentManager";

export interface IAppointmentManager {
  OnChanged: CustomLibary.Event<OutlookAppointmentDto>;
  OnStarted: CustomLibary.Event<boolean>;
  OnDateTimeChanged: CustomLibary.Event<DateTimePeriodDto>;
  OnRecipientsChanged: CustomLibary.Event<Array<OutlookRecipientDto>>;
  OnRecurrenceChanged: CustomLibary.Event<OutlookAppointmentRecurrenceDto>;
  currentResources?: OutlookRecipientDto[];
  Organizer: OutlookRecipientDto | undefined;
  GetAppointment(): OutlookAppointmentDto;
  Start(): void;
  UpdateResources(resources: Array<OutlookRecipientDto>): void;
  AddResources(resources: OutlookRecipientDto[], locations: string[]): boolean;
  RemoveResources(resourceEmails: string[], locations: string[]): boolean;
  UpdateRecipients(recipients: OutlookRecipientDto[]): boolean;
  UpdateAppointmentBaseInfo(apptDto: OutlookAppointmentBaseInfoDto): boolean;
  GetRecipients(): OutlookRecipientDto[];
  SetLocations(locations: string[]): boolean;
  UpdateBodyForSendToAll(key: string, sendToAll: boolean): Promise<boolean>;
  IsNewBooking(): boolean;
  GetMessageUrl(): string;
  GetOrganizer(): Promise<void>;
  SaveDataResourceInfo(data: Record<string, any>, key: string): void;
  ReplaceLocation(locations: string[]): void;
  ConvertTimeDisplayLocalUTC(dateTime: Date): Date;
  CreateNewUid(): Promise<string>
}

